import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { useLocale } from "../../hooks/useLocale";
import { Logo } from "../ui/Logo";

/** Shown after login when the staff member works in several branches (v2). The server re-checks the choice on every request. */
export function BranchPicker() {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const { user, selectBranch, logout } = useAuth();
  const branches = user?.branches ?? [];
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-cosmic-navy via-[#1a1f52] to-cosmic-purple p-4">
      <div className="w-full max-w-md space-y-4 rounded-3xl bg-white p-7 shadow-cosmic">
        <div className="flex justify-center"><Logo variant="wordmark" className="h-12" /></div>
        <div>
          <h1 className="text-lg font-black">{t("branch.pickTitle")}</h1>
          <p className="text-xs text-gray-500">{t("branch.pickSubtitle")}</p>
        </div>
        <ul className="space-y-2">
          {branches.map((b) => (
            <li key={b.id}>
              <button type="button" onClick={() => selectBranch(b.id)} className="flex w-full items-center justify-between rounded-2xl border border-cosmic-silver px-4 py-3 text-start hover:border-cosmic-purple hover:bg-purple-50">
                <span className="text-sm font-black">{locale === "ar" && b.name_ar ? b.name_ar : b.name}</span>
                <span className="num rounded-lg bg-gray-100 px-2 py-0.5 font-mono text-xs font-bold text-gray-600">{b.code}</span>
              </button>
            </li>
          ))}
        </ul>
        <button type="button" onClick={logout} className="btn-ghost w-full">{t("header.logout")}</button>
      </div>
    </div>
  );
}
